module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "赠送礼品",
      "width": "640"
    },
    on: {
      "on-visible-change": _vm.onVisible
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 80
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "礼品"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入礼品名称"
    },
    model: {
      value: (_vm.giftName),
      callback: function($$v) {
        _vm.giftName = $$v
      },
      expression: "giftName"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "12px"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saving
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存")])], 1), _vm._v(" "), _c('table', {
    staticClass: "track-list"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("赠送时间")]), _vm._v(" "), _c('th', [_vm._v("礼品")]), _vm._v(" "), _c('th', [_vm._v("操作人")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.records), function(item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', [_vm._v(_vm._s(_vm.formatTime(item.gmtCreate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.giftName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.creatorName))])])
  }), _vm._v(" "), (!_vm.records.length) ? _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center",
      "color": "#999"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("暂无赠送记录")])]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0855b413","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/OrderGiftModal.vue
// module id = 1610
// module chunks = 8